import Block from '@/components/Block'
import Button from '@/components/Button'
import { Stack } from '@/components/Layout'
import Text from '@/components/Text'
import { coreLayoutContainer, coreLayoutSection } from '@/constants/measured-scope'
import { useAuth } from '@/context/auth'
import { useModal } from '@/context/modal'
import { toLoginAuthUrl } from '@/lib/authUrl'
import { SeriesInfoContent } from '@/shared/api-generated-types'
import classNames from 'classnames/bind'
import DOMPurify from 'isomorphic-dompurify'
import { useTranslation } from 'next-i18next'
import * as styles from './style'

const cx = classNames.bind(styles)

export interface Props extends Partial<SeriesInfoContent> {
  className?: string
}

const SeriesInfoBlock = ({ className = '', ...props }: Props): JSX.Element => {
  const { t } = useTranslation('classes')
  const classes = cx({
    root: true,
    [className]: true,
  })
  const {
    state: { user },
  } = useAuth()

  const { dispatch } = useModal()

  function handleOnClick(): void {
    if (!user) {
      // TODO. This action should come from the server rather than the client.
      window.location.href = toLoginAuthUrl(window.location.pathname)
    }
    if (user) {
      dispatch({ type: 'TOGGLE' })
    }
  }

  return (
    <header className={coreLayoutSection}>
      <Stack x className={`${classes} ${coreLayoutContainer}`} alignItems="start" spaceBetweenX="lg">
        <Stack alignSelf="center" spaceBetweenY="sm" y>
          {props.name ? (
            <Text
              weight="lg"
              size="xl"
              responsiveSize={{
                desktop: 'xxl',
              }}
              className="fc-primary"
            >
              {props.name}
            </Text>
          ) : null}

          {props.description ? (
            <Text weight="sm">
              <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.description) }} />
            </Text>
          ) : null}
          {props.hasSessions && (
            <Block className={`pl-0`} spacing="sm">
              <Button
                size="md"
                iconLeft="checkbox"
                label={t('bookMultipleSessions.buttonText')}
                onClick={handleOnClick}
                className={styles.button}
              />
            </Block>
          )}
        </Stack>
        {props.imageUrl ? (
          <div className={styles.imageContainer}>
            <div>
              <img src={props.imageUrl} alt={props.name ?? ''} className={styles.image} loading="lazy" />
            </div>
          </div>
        ) : null}
      </Stack>
    </header>
  )
}
export default SeriesInfoBlock
